// Prevent embedding site in iframe
const { self, top } = window;
if (top !== self) {
	// Erase site in case setting location fails
	document.body.innerHTML = "";
	top.location = self.location;
	// Stop scripts in case attacker prevents above navigation
	throw Error;
}
